import { render } from "./AtendimentosWhatsAppCommonView.vue?vue&type=template&id=765a4b34"
import script from "./AtendimentosWhatsAppCommonView.vue?vue&type=script&lang=js"
export * from "./AtendimentosWhatsAppCommonView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__